import React from 'react';
import { withTranslation } from 'react-i18next';

import { AuthConsumer } from "../context/AuthContext";
import { authContext } from "../context/AuthContext";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import withStyles from '@mui/styles/withStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { withRouter } from "react-router-dom";
import { Menu } from '@mui/material';
import {Fade} from '@mui/material';
import { PolicyDialog } from './helper/Dialogs'


import MenuItem from '@mui/material/MenuItem';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
    },
    appBar: {
        backgroundColor: "#0021a5",
        height: "inherit"
    },
    drawerPaper: {
        background: "#0021a5",
        backgroundColor: "#0021a5",
        height: "inherit",
    },
    menuPaper: {
        backgroundColor: "#0021a5",
        color: "white",
        // height: "inherit",
    },
    menuItemPaper:{
        "&:hover":{
            backgroundColor: "white",
            color: "#0021a5",
        }
    },
    toolbar: {
        minHeight: 0
    },
    '&. MuiTypography-colorPrimary':{
        color: "white",
    }
});



class Header extends React.Component {
    static contextType = authContext;

    

    constructor(props) {
        super(props);
        this.state = {
            showDrawer: false,
            backGroundLanguageEng: '#0021a5',
            backGroundLanguageEsp: '#333',
            anchorEl: null,
            policyDialogOpen : false

        };
    }

    

    handleClick = (event) => {
        this.setState({anchorEl: event.currentTarget});
    };
    handleClose = () => {
        this.setState({anchorEl: null});
    };

    setPolicyDialogClose = (bo) => {
        this.setState({
            policyDialogOpen : bo
        })
    }

    handleStudentPolicy = () => {
        console.log('student policy clicked')
        this.setPolicyDialogClose(true)
        this.setState({anchorEl: null});
    }

    



    toggleDrawer(visibility) {
        this.setState({ showDrawer: visibility });
    }

    logout = (event) => {
        console.log(this.props);
        let saml = this.context.logout();
        if (saml) {
            this.props.history.replace('/logoutSAML');

        }
    }


    changeLanguage = (lng) => {
        this.props.i18n.changeLanguage(lng);
        if(lng==='en'){
            this.setState({
                backGroundLanguageEng: '#0021a5',
                backGroundLanguageEsp: '#333'
            })
        }
        else{
            this.setState({
                backGroundLanguageEsp: '#0021a5',
                backGroundLanguageEng: '#333'
            })
        }
        
    };

    render() {
        const { classes } = this.props;
        const open = Boolean(this.state.anchorEl);
        

        return (
            <div style={{ paddingBottom: `200px`}}>
                <AppBar id="header" position="fixed" className={classes.appBar}>
                    <Toolbar className={classes.toolbar}>
                        <Box className={classes.title} >
                            <Box display="inline">
                                <Link href="https://sfyl.ifas.ufl.edu">
                                    <img alt="UF/IFAS" src="/images/IFASExtWeb2013white.svg" style={{ width: '200px', height: '45px', marginRight: '15px', marginLeft: '15px' }}></img>
                                </Link>
                            </Box>
                            <Box display={{ xs: 'none', md: 'inline' }}>
                                <Link href="/" className="navlink">
                                    Home
                                </Link>
                            </Box>
                            <AuthConsumer>
                                {({ authenticated }) =>
                                    authenticated ? (
                                        <Box display={{ xs: 'none', md: 'inline' }}>
                                            <Link href="/dashboard" className="navlink">
                                                Dashboard
                                            </Link>
                                        </Box>
                                    ) : null
                                }
                            </AuthConsumer>

                            <AuthConsumer>
                                {({ authenticated, roles }) =>
                                    authenticated && (roles.isRoleAdmin ||  roles.isOnlineTrainingEditor || roles.isClassroomTrainingAdmin || roles.isUserAdmin || roles.isOnlineTrainingAdmin || roles.isClassroomTrainingManager || roles.isProgramCoordinator || roles.isInstructorAdministrator) ? (
                                        <Box display={{ xs: 'none', md: 'inline' }}>
                                            <Link href="/administration" className="navlink">
                                                Admin
                                            </Link>
                                            
                                        </Box>
                                    ) : null
                                }
                            </AuthConsumer>

                            <Box display={{ xs: 'none', md: 'inline' }}>

                                <Link href="/certified" className="navlink" >
                                    Certificate Search
                                </Link>

                                <Link 
                                className="navlink" 
                                id="fade-button"
                                aria-controls={open ? 'fade-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={this.handleClick}
                               
                                >
                                    Resources
                                </Link>

                                <Link href="https://ffl.ifas.ufl.edu/gi-bmp-training-help/" target="_blank" className="navlink">
                                    Help
                                </Link>
                                <Link href="https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/gi-bmp-contacts/" target="_blank" className="navlink">
                                    Contact Us
                                </Link>
                            </Box>

                           
                        </Box>
                        <Menu
                            id="fade-menu"
                            MenuListProps={{
                            'aria-labelledby': 'fade-button',
                            }}
                            anchorEl={this.state.anchorEl}
                            open={open}
                            onClose={this.handleClose}
                            TransitionComponent={Fade}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                            transformOrigin={{vertical: 'top', horizontal: 'left'}}
                            classes= {{ paper: classes.menuPaper }}
                            sx={{
                                color: "#0021a5",
                                // background: "#0021a5",
                              }}
                              PaperProps={{
                                sx:{
                                    backgroundColor: "#0021a5"
                                }
                            }}
                            
                        >
                            <MenuItem className="resource-menu" onClick={this.handleClose}>
                                <Link 
                                href="https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/gi-bmp-manual/" 
                                 className="resource" 
                                style={{color:'white'}}
                                >
                                    GI-BMP Manual
                                </Link>
                            </MenuItem>
                            
                            <MenuItem className="resource-menu" onClick={this.handleStudentPolicy} 
                            style={{color:'white'}}
                             >Online and DVD Student Policies 
                            </MenuItem>
                            <MenuItem className="resource-menu" onClick={this.handleClose}>
                                <Link 
                                href ="https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/fertilizer-certification/ " 
                                style={{color:'white'}}
                                >
                                    FDACS Limited Fertilizer Applicator license (LF) 
                                </Link> 
                                
                            </MenuItem>
                            <MenuItem className="resource-menu" onClick={this.handleClose}> 
                            <Link 
                            href="https://sfyl.ifas.ufl.edu/find-your-local-office/ " 
                            style={{color:'white'}} 
                            >
                            Local Extension offices 
                            </Link>
                            
                            </MenuItem>
                        </Menu>
                                   

                        <PolicyDialog
                            open={this.state.policyDialogOpen}
                            onClose={() => this.setPolicyDialogClose(false)}
                        /> 


                        <Box display={{ xs: 'none', md: 'block' }} height="100%">
                            <AuthConsumer>
                                {({ authenticated, user }) =>
                                    authenticated ? (
                                        <Link  onClick={this.logout} className="navlink">
                                            Logout
                                        </Link>
                                    ) : (
                                            <Link href="/login" className="navlink">
                                                Login
                                            </Link>
                                        )
                                }
                            </AuthConsumer>
                        </Box>
                        <Box display={{ xs: 'block', md: 'none' }} >
                            <IconButton color="inherit" onClick={() => this.toggleDrawer(true)} size="large">
                                <MenuIcon fontSize='large' />
                            </IconButton>
                            <Drawer 
                                id="drawer" 
                                anchor={'right'} 
                                open={this.state.showDrawer} 
                                onClose={() => this.toggleDrawer(false)}
                                // classes={{ paper: classes.drawerPaper }}
                                PaperProps={{
                                    sx:{
                                        backgroundColor: "#0021a5"
                                    }
                                }}
                            >
                                <div id="hamburger_icon_style">
                                <Grid container justifyContent="flex-start">
                                    <IconButton
                                        style={{ color: "white", width: "auto", margin: ".5em" }}
                                        onClick={() => this.toggleDrawer(false)}
                                        size="large">
                                        <CloseIcon fontSize='large' />
                                    </IconButton>
                                </Grid>
                                <List>
                                    <ListItem>
                                        <Link href="/" className="navlink">
                                            Home
                                        </Link>
                                    </ListItem>
                                </List>

                                <AuthConsumer>
                                    {({ authenticated }) =>
                                        authenticated ?
                                            <List>
                                                <ListItem>
                                                    <Link href="/dashboard" className="navlink">
                                                        Dashboard
                                                    </Link>
                                                </ListItem>
                                            </List>
                                            :
                                            null
                                    }
                                </AuthConsumer>
                                <AuthConsumer>
                                {({ authenticated, roles }) =>
                                    authenticated && (roles.isRoleAdmin ||  roles.isOnlineTrainingEditor || roles.isClassroomTrainingAdmin || roles.isUserAdmin || roles.isOnlineTrainingAdmin || roles.isClassroomTrainingManager || roles.isProgramCoordinator || roles.isInstructorAdministrator) ? 
                                        <List>
                                            <ListItem>
                                                <Link href="/administration" className="navlink">
                                                    Admin
                                                </Link>
                                            </ListItem>
                                      
                                        </List>
                                        :
                                        null
                                    }
                                </AuthConsumer>

                                <List>
                                    <ListItem>
                                        <Link href="/certified" className="navlink">
                                            Certified
                                        </Link>
                                    </ListItem>
                                    <ListItem>
                                        <Link 
                                            href="#"
                                            className="navlink" 
                                            id="fade-button"
                                            aria-controls={open ? 'fade-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            onClick={this.handleClick}
                                           
                                            >
                                            Resources
                                        </Link>

                                    </ListItem>
                                    <ListItem>
                                        <Link href="https://ffl.ifas.ufl.edu/gi-bmp-training-help/" target="_blank" className="navlink">
                                            Help
                                        </Link>
                                    </ListItem>
                                    <ListItem>
                                         <Link href="https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/gi-bmp-contacts/" target="_blank" className="navlink">
                                            Contact Us
                                        </Link>
                                    </ListItem>
                                    <ListItem>
                                        <AuthConsumer>
                                            {({ authenticated, user }) =>
                                                authenticated ? (
                                                    <Link onClick={this.logout} className="navlink">
                                                        Logout
                                                    </Link>

                                                ) : (
                                                    <Link href="/login" className="navlink">
                                                        Login
                                                    </Link>
                                                )
                                            }
                                        </AuthConsumer>
                                    </ListItem>
                                    
                                </List>
                                </div>
                            </Drawer>
                        </Box>
                    </Toolbar>
                

                    <Box id="sub-header">
                        <Box display={{ xs: 'none', md: 'block' }} >
                            <Box>
                            <h1><strong>Green Industries Best Management Practices</strong></h1>
                            </Box> 
                            <Box id="language-header"  >
                                    <Box>

                                        <ButtonGroup size="smalll" variant="contained" color="primary" aria-label="contained primary button group">
                                            <Button onClick={() => this.changeLanguage('en')} style={{ backgroundColor: this.state.backGroundLanguageEng }} >English</Button>
                                            <Button onClick={() => this.changeLanguage('es')} style={{ backgroundColor: this.state.backGroundLanguageEsp }} >Spanish</Button>
                                        </ButtonGroup>
                                    </Box>
                            </Box>
                        </Box>
                        
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <Link href="https://ffl.ifas.ufl.edu">
                                <img alt="FFL" 
                                src="/images/FL_Friendly_Land_GIBMP.png" 
                                            href="https://ffl.ifas.ufl.edu" 
                                            style={{ width: '200px', height: '45px', marginRight: '15px', marginLeft: '15px' }}></img>
                            </Link>
                        </Box>

                        <Box display={{ xs: 'block', md: 'none' }} >
                        <Box id ='titleResp'>
                            
                            
                            <h1><strong>GI-BMP</strong></h1>

                            <Box id="language-header-resp"  >
                                        <Box display={{ xs: 'block' }} >
                                            <ButtonGroup size="small" variant="contained" color="primary" aria-label="contained primary button group">
                                                <Button onClick={() => this.changeLanguage('en')} style={{ backgroundColor: this.state.backGroundLanguageEng }} >English</Button>
                                                <Button onClick={() => this.changeLanguage('es')} style={{ backgroundColor: this.state.backGroundLanguageEsp }} >Spanish</Button>
                                            </ButtonGroup>
                                        </Box>
                            </Box>
                        
                            
                        </Box>
                    </Box>

                   
                        
                    </Box>
                </AppBar>

            </div>

        );
    }
}

export default withRouter(withStyles(styles, { withTheme: true }) (withTranslation() (Header)));
